import { ArrowBack } from '@mui/icons-material';
import { Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ScenarioCreateInput, useAdminScenarioPlansQuery, useCreateScenarioMutation } from '../../../../../api/gql';
import { FullSizeLoader } from '../../../../../components/FullSizeLoader';
import { PageHeader } from '../../../../../components/PageHeader';
import { useSafeNavigation } from '../../../../../hooks/useSafeNavigation';
import { PageContent, PageLayout } from '../../../../../layout';
import { ScenarioForm } from '../../../../../modules/scenarios/ScenarioForm';
import { notify } from '../../../../../utils/notification';

const TRANS_NS = 'universal-reminding';

export const CreateScenarioPage = () => {
  const { t } = useTranslation(TRANS_NS, { keyPrefix: 'scenarios.create' });
  const { safeNavigate } = useSafeNavigation();
  const { mutate, isPending } = useCreateScenarioMutation({
    onSuccess: () => {
      notify.positive({ message: t('mutation.success') });
      safeNavigate('/admin/universal-reminding/scenarios');
    },
    onError: (error) => {
      console.error(error);
      notify.negative({
        message: t('mutation.error'),
      });
    },
  });

  const { data: scenarioPlans, isLoading: isPlansLoading, isError: isPlansError } = useAdminScenarioPlansQuery();

  const onSubmit = (data: ScenarioCreateInput) => {
    mutate({
      input: {
        ...data,
      },
    });
  };

  return (
    <PageLayout>
      <PageHeader title={t('title')} backRouteTo={'/admin/universal-reminding/scenarios'} Icon={ArrowBack} />
      <PageContent sx={{ justifyContent: 'flex-start', alignItems: 'flex-start' }}>
        <Paper sx={{ width: '100%', p: 4, position: 'relative' }}>
          {isPlansLoading ? <FullSizeLoader /> : null}
          {isPlansError ? <div>Nedaří se načíst plány scénářů. Zkuste to prosím později.</div> : null}
          {scenarioPlans ? (
            <ScenarioForm
              onSubmit={onSubmit}
              isLoading={isPending}
              isDisabled={isPending}
              scenarioPlans={scenarioPlans.scenarioPlans}
            />
          ) : null}
        </Paper>
      </PageContent>
    </PageLayout>
  );
};
